import Vue from "vue";
import OrganizerRegistration from "./layout/OrganizerRegistration.vue";
import { __ } from "../admin/helpers";
import OrganizerRegistrationSuccess from "./layout/OrganizerRegistrationSuccess.vue";

Vue.mixin({
  methods: {
    __: function (key) {
      return __(key);
    },
  },
});

new Vue({
  el: '#app',
  components: {
    OrganizerRegistration,
    OrganizerRegistrationSuccess,
  },
});
